{
  "agreements": {
    "title": "Agreements",
    "listHeading": "Agreements · {{count}}",
    "listHint": "Pick an agreement — editor on the right.",
    "editingNow": "Editing now",
    "creatingNow": "New agreement",
    "empty": "No agreements yet.",
    "newAgreement": "New agreement",
    "systemBadge": "System",
    "inactiveBadge": "Disabled",
    "versionLabel": "Version {{version}}",
    "acceptancesLabel": "Acceptances: {{count}}",
    "pickHint": "Pick an agreement on the left or create a new one.",
    "fields": {
      "key": "Key",
      "keyHint": "Unique identifier used in code. Immutable for system agreements.",
      "keyPlaceholder": "seedance_avatar_registration",
      "title": "Title",
      "body": "Agreement text",
      "active": "Active"
    },
    "systemKeyReadonly": "Public URL: /agreements/{{key}}. The key of a system agreement cannot be changed.",
    "create": "Create",
    "save": "Save",
    "saving": "Saving…",
    "delete": "Delete",
    "deleteConfirm": "Delete this agreement? This cannot be undone.",
    "systemNoDelete": "A system agreement cannot be deleted."
  },
  "styleCatalog": {
    "headTitle": "Style catalog",
    "title": "Style catalog",
    "tabs": {
      "genres": "Genres",
      "tones": "Narrative tones",
      "mediums": "Mediums"
    },
    "mediumBaseImage": "System base image for medium previews",
    "noBaseImage": "Not uploaded",
    "uploadBaseImage": "Upload",
    "deleteBaseImage": "Remove",
    "deleteBaseImageConfirm": "Remove the system base image?",
    "listTitle": "List",
    "filterPlaceholder": "Search by name…",
    "clearFilter": "Clear filter",
    "add": "Add",
    "hidden": "hidden",
    "creatingNow": "Creating new",
    "editingNow": "Currently editing",
    "newItem": "New item",
    "editItem": "Editing: {{label}}",
    "label": "Label",
    "category": "Category",
    "uncategorizedGroup": "Uncategorized",
    "promptFragment": "Prompt fragment",
    "hiddenLabel": "Hide from pickers",
    "projectsUsing": "Projects with this value: {{count}}",
    "generatePreview": "Generate preview",
    "deleteReferenceImage": "Remove preview",
    "deleteReferenceImageConfirm": "Remove this medium preview?",
    "imageProviderLabel": "Generation model",
    "dashscopeModelLabel": "DashScope model",
    "geminiModelLabel": "Gemini model",
    "openrouterModelLabel": "OpenRouter model",
    "noImageProviders": "No configured image generation providers (Studio → AI).",
    "generatingPreview": "Generating preview… {{progress}}%",
    "save": "Save",
    "delete": "Delete",
    "renameConfirm": "Renaming affects {{count}} project(s) that still store the old label. Continue?",
    "deleteConfirm": "Delete «{{label}}»?"
  },
  "splashAnnouncements": {
    "title": "Announcements",
    "listHeading": "Announcements · {{count}}",
    "listHint": "News and offers slider on the projects page.",
    "empty": "No announcements yet.",
    "create": "Create",
    "newAnnouncement": "New announcement",
    "creatingNow": "Creating",
    "editingNow": "Editing",
    "untitled": "Untitled",
    "pickHint": "Pick an announcement on the left or create a new one.",
    "meta": "Version {{version}} · dismissals: {{dismissals}}",
    "save": "Save",
    "saving": "Saving…",
    "delete": "Delete",
    "deleteConfirm": "Delete this announcement? User dismissals will be removed as well.",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "preview": "Preview",
    "previewNoTitle": "Announcement title",
    "runtimeStatus": {
      "draft": "Draft",
      "scheduled": "Scheduled",
      "live": "Live",
      "expired": "Expired"
    },
    "audience": {
      "all": "All companies",
      "selected": "Selected companies"
    },
    "presets": {
      "river_glass": "River glass",
      "violet_split": "Violet split",
      "cinematic": "Cinematic",
      "amber_signal": "Amber signal",
      "midnight_minimal": "Midnight minimal"
    },
    "blockers": {
      "title_ru_missing": "Russian title is missing",
      "title_en_missing": "English title is missing",
      "companies_missing": "no companies selected",
      "window_invalid": "end time is before start time"
    },
    "fields": {
      "titleRu": "Title (RU)",
      "titleEn": "Title (EN)",
      "bodyRu": "Body (RU)",
      "bodyEn": "Body (EN)",
      "ctaLabelRu": "Button (RU)",
      "ctaLabelEn": "Button (EN)",
      "ctaUrl": "Button link",
      "ctaUrlPlaceholder": "/projects/new or https://…",
      "ctaUrlHint": "A relative in-app path or an HTTPS link.",
      "stylePreset": "Card style",
      "position": "Order",
      "positionHint": "Lower comes first in the slider.",
      "startsAt": "Starts at",
      "endsAt": "Ends at",
      "audience": "Audience",
      "companySearch": "Search companies…",
      "companiesEmpty": "No companies found.",
      "companiesSelected": "Companies selected: {{count}}",
      "media": "Image or video",
      "uploadMedia": "Upload media",
      "uploadPoster": "Video poster",
      "removePoster": "Remove poster",
      "removeMedia": "Remove media",
      "mediaHint": "Image up to 10 MB or video up to 100 MB. Without media the preset background is used."
    }
  },
  "presentations": {
    "title": "Presentations",
    "defaultTitle": "New presentation",
    "create": "Create presentation",
    "createConfirm": "Create",
    "search": "Search by title…",
    "empty": "No presentations yet.",
    "linkCopied": "Link copied",
    "saving": "Saving…",
    "saveFailed": "Save failed",
    "publishSettings": "Publish settings",
    "publicUrl": "Public URL",
    "pinEnabled": "Require PIN to view",
    "pinPlaceholder": "4–8 digits",
    "pinPrompt": "Enter PIN to view this presentation",
    "pinInvalid": "Invalid PIN",
    "pinSubmit": "Continue",
    "unavailableTitle": "Unavailable",
    "noSlides": "No slides to show",
    "noSlideSelected": "Select a slide",
    "untitledSlide": "Untitled slide",
    "managedNote": "Slides of this presentation come from presentations/{{slug}}/deck.yml. Edit the file and run bin/rails presentations:sync: the next sync overwrites changes made here.",
    "addSlide": "Add slide",
    "hideSlide": "Hide slide from viewer",
    "deleteConfirm": "Delete this presentation?",
    "deleteSlideConfirm": "Delete this slide?",
    "enMissing": "{{count}} EN fields still empty",
    "menu": "Menu",
    "statusPublished": "Published",
    "statusDraft": "Draft",
    "columns": {
      "title": "Title",
      "status": "Status",
      "updated": "Updated",
      "slides": "Slides",
      "language": "Language",
      "author": "Author",
      "link": "Link"
    },
    "fields": {
      "titleRu": "Title (RU)",
      "version": "Version",
      "description": "Description",
      "defaultLocale": "Default locale"
    },
    "tabs": {
      "content": "Content",
      "slide": "Slide",
      "presentation": "Presentation"
    },
    "actions": {
      "edit": "Edit",
      "preview": "Preview",
      "exportPdf": "Export PDF",
      "downloadPdf": "Download PDF",
      "duplicate": "Duplicate",
      "publish": "Publish",
      "unpublish": "Unpublish",
      "revokeLink": "Revoke link"
    },
    "export": {
      "title": "Export presentation",
      "saveHint": "In the print dialog, choose Save as PDF as the destination.",
      "rendering": "Preparing PDF…",
      "failed": "Could not prepare the PDF. {{error}}",
      "timeout": "Rendering took longer than five minutes, please try again.",
      "preparing": "Preparing slides…"
    },
    "contentForm": {
      "title": "Title",
      "subtitle": "Subtitle",
      "body": "Body text",
      "description": "Description",
      "caption": "Caption",
      "image": "Image",
      "video": "Video",
      "leftImage": "Left image",
      "rightImage": "Right image",
      "leftCaption": "Left caption",
      "rightCaption": "Right caption",
      "imageN": "Image {{n}}",
      "screenshotN": "Screenshot {{n}}",
      "overlayTitle": "Overlay title",
      "overlayPosition": "Overlay position",
      "positionTop": "Top",
      "positionCenter": "Center",
      "positionBottom": "Bottom",
      "beforeLabel": "Before label",
      "afterLabel": "After label",
      "beforeImage": "Before image",
      "afterImage": "After image",
      "beforeText": "Before text",
      "afterText": "After text",
      "autoplay": "Autoplay",
      "loop": "Loop",
      "muted": "Muted",
      "date": "Date",
      "value": "Value",
      "label": "Metric label",
      "itemsSection": "List items",
      "featuresSection": "Features",
      "stepsSection": "Steps",
      "metricsSection": "Metrics",
      "itemCount": "{{count}} items",
      "itemN": "Item {{n}}",
      "featureN": "Feature {{n}}",
      "stepN": "Step {{n}}",
      "metricN": "Metric {{n}}",
      "addItem": "Add item",
      "addStep": "Add step",
      "addMetric": "Add metric",
      "removeItem": "Remove",
      "moveUp": "Move up",
      "moveDown": "Move down",
      "stepStatus": "Status",
      "statusDone": "Done",
      "statusCurrent": "Current",
      "statusUpcoming": "Upcoming"
    }
  },
  "systemPrompts": {
    "title": "System prompts",
    "noTemplates": "No templates in the database.",
    "filterPlaceholder": "Search by name…",
    "clearFilter": "Clear search",
    "filterEmpty": "No matches.",
    "status": {
      "new": "New",
      "update": "Update",
      "conflict": "Conflict",
      "orphan": "Not in code"
    },
    "diff": {
      "showUnchanged_one": "{{count}} more unchanged line",
      "showUnchanged_other": "{{count}} more unchanged lines",
      "noChanges": "The text does not change."
    },
    "upstream": {
      "title": "Updates from code",
      "subtitle": "The release brought new prompts and changes. Nothing in the database changes without your decision: until then the system keeps using the current text.",
      "pinnedHint": "New {{new}} · updates {{update}} · conflicts {{conflict}}",
      "emptyTitle": "Everything is in sync",
      "emptyDescription": "No new prompts, updates or conflicts with code.",
      "conflict": {
        "title": "Conflicts",
        "hint": "The prompt changed both in the database and in code. For each conflict take the database version, the code version or both, and adjust the result if needed. The assistant can fill in the results for you.",
        "baseUnknown": "Common ancestor unknown",
        "count_one": "{{count}} conflict",
        "count_other": "{{count}} conflicts",
        "autoMerge": "Changes don't overlap — review the auto-merge",
        "resolve": "Resolve"
      },
      "update": {
        "title": "Conflict-free updates",
        "hint": "This prompt was not edited in the database since the last apply — you can take the text from code.",
        "applyAll_one": "Apply {{count}} update",
        "applyAll_other": "Apply {{count}} updates",
        "showDiff": "Changes",
        "loadingDiff": "Loading…",
        "apply": "Apply",
        "confirmTitle": "Apply updates from code?",
        "confirmMessage_one": "The text of {{count}} prompt in the database will be replaced with the code version. The previous text stays in the version history.",
        "confirmMessage_other": "The texts of {{count}} prompts in the database will be replaced with the code versions. The previous texts stay in the version history."
      },
      "new": {
        "title": "New prompts",
        "hint": "They are not in the database yet: the system reads the text straight from code. Once added, the prompt can be edited in Studio.",
        "selectAll": "Select all",
        "selectNone": "Clear selection",
        "addSelected_one": "Add {{count}} prompt",
        "addSelected_other": "Add {{count}} prompts",
        "preview": "Text",
        "confirmTitle": "Add prompts from code?",
        "confirmMessage_one": "{{count}} prompt with the code text will be added to the database.",
        "confirmMessage_other": "{{count}} prompts with the code texts will be added to the database.",
        "add": "Add"
      }
    },
    "merge": {
      "save": "Save",
      "saveAnyway": "Save anyway",
      "saveBlocked": "Resolve all conflicts first",
      "progress": "Resolved {{resolved}} of {{total}}",
      "noConflicts": "No conflicts: changes merged automatically.",
      "askAgent": "Propose a resolution",
      "askingAgent": "Assistant is thinking…",
      "agentDone_one": "The assistant filled in the result for {{count}} conflict. Check it before saving.",
      "agentDone_other": "The assistant filled in the result for {{count}} conflicts. Check them before saving.",
      "agentPartial_one": "The assistant gave no reliable resolution for {{count}} conflict ({{reasons}}). Resolve it manually.",
      "agentPartial_other": "The assistant gave no reliable resolution for {{count}} conflicts ({{reasons}}). Resolve them manually.",
      "agentReject": {
        "unknown_choice": "unknown choice",
        "missing_text": "empty proposal",
        "conflict_markers": "conflict markers",
        "lost_placeholders": "lost placeholders"
      },
      "mainField": "Main text",
      "facingField": "Facing {{facing}}",
      "auto": {
        "ours": "From database",
        "theirs": "From code",
        "both": "Same in database and code",
        "deleted": "(lines removed)"
      },
      "take": "Take",
      "takeAllOurs": "Take database everywhere",
      "takeAllTheirs": "Take code everywhere",
      "showMore_one": "{{count}} more line",
      "showMore_other": "{{count}} more lines",
      "customAria": "Result of conflict {{number}}",
      "customPlaceholder": "Take one of the versions or write the result yourself. Clearing the field after editing drops these lines.",
      "oursTitle": "In database (your version)",
      "theirsTitle": "From code (new release)",
      "sideEmpty": "Lines removed",
      "agentTitle": "Result proposed by the assistant",
      "lowConfidence": "check it"
    },
    "history": {
      "open": "History",
      "title": "Version history",
      "loading": "Loading…",
      "empty": "No versions yet.",
      "current": "current",
      "diffHint": "Selected version → current database text.",
      "restore": "Restore",
      "restoreTitle": "Restore this version?",
      "restoreMessage": "The prompt text in the database will be replaced with the selected version, including facing-view prompts. The current text stays in the history.",
      "warnings_one": "{{count}} warning",
      "warnings_other": "{{count}} warnings",
      "source": {
        "baseline": "Initial version",
        "code_new": "Added from code",
        "code_update": "Updated from code",
        "manual": "Edited in Studio",
        "merge_manual": "Manual merge",
        "merge_agent": "Merge with assistant",
        "restore": "Version restored"
      }
    },
    "editor": {
      "conflictNotice": "Code was updated while this prompt was edited in the database — resolve the conflict, otherwise release changes won't take effect.",
      "updateNotice": "Code has a new version of this prompt — apply it or keep the current one.",
      "openMerge": "Open merge"
    }
  },
  "facingEstablishing": {
    "sectionTitle": "Establishing shot by view",
    "sectionHint": "System instructions for generating a location reference per view (3/4, topview, north, south, east, west).",
    "three_quarter": "3/4",
    "topview": "Topview",
    "north": "North",
    "south": "South",
    "east": "East",
    "west": "West",
    "empty": "—",
    "placeholder": "Leave empty to use the global prompt"
  },
  "aiSettings": {
    "pageTitle": "AI API settings",
    "pageSubtitle": "Groups: Text (ChatGPT via n8n), Images (GPT Image, Qwen Image, Wan 2.7 Image, OpenRouter, Google Gemini image, covers and references), Video (Kling, WAN, Seedance 2.0, Google Veo), Processing (Topaz), plus Network (outbound HTTP proxy). Secrets are not shown; leave the key field empty to keep the saved value.",
    "headTitle": "AI API settings",
    "dashscopeEngineSummary": "Storyboard Qwen / Wan Image in projects: {{summary}}",
    "navGroups": {
      "text": "Text",
      "images": "Images",
      "video": "Video",
      "postproduction": "Processing",
      "network": "Network"
    },
    "currentlyEditing": "Currently editing",
    "sectionsNavTitle": "Sections",
    "sectionsNavHint": "Pick a block — fields appear on the right.",
    "saveSettings": "Save settings",
    "savingSettings": "Saving…",
    "common": {
      "webhookUrl": "Webhook URL",
      "authMode": "Authorization mode",
      "tokenSecret": "Token / secret",
      "tokenSaved": "(already saved)",
      "tokenNotSet": "(not set)",
      "replaceTokenPlaceholder": "•••••••• — enter a new value to replace",
      "enterTokenPlaceholder": "Enter token",
      "requestTimeoutSec": "Request timeout (s)",
      "pollIntervalSec": "Poll interval (s)",
      "pollMaxAttempts": "Max poll attempts",
      "apiKey": "API Key",
      "apiKeySaved": "(already saved)",
      "apiKeyNotSet": "(not set)",
      "apiKeyPlaceholder": "API Key from Kling console",
      "baseUrl": "Base URL",
      "baseUrlRegion": "Base URL (region)",
      "defaultModel": "Default model",
      "defaultVideoModel": "Default video model",
      "defaultModelVideo": "Default model (video)",
      "enablePrefix": "Enable",
      "testUsesSavedHint": "The request uses saved URL and token. The “Enable…” checkbox is not required for testing; if you changed fields — save first.",
      "testUsesSavedHintSaved": "saved",
      "bearerHeaderOption": "Header \"Bearer\" (as in n8n CAPAA)",
      "authorizationBearerOption": "Authorization: Bearer …",
      "accessKey": "Access Key",
      "accessKeySaved": "(already saved)",
      "accessKeyNotSet": "(not set)",
      "accessKeyPlaceholder": "Access Key from Kling console",
      "secretKey": "Secret Key",
      "secretKeySaved": "already saved",
      "secretKeyNotSet": "not set",
      "secretKeyReplacePlaceholder": "•••••••• — enter a new Secret Key to replace",
      "secretKeyStorageHint": "Stored in the encrypted secret field; shown only once in the Kling console.",
      "resolution": "Resolution",
      "model": "Model",
      "optional": "optional",
      "systemPrompts": "System prompts",
      "providersTitle": "Providers",
      "documentation": "Documentation",
      "videoPollIntervalSec": "Video poll interval (s)",
      "generateContentTimeoutSec": "generateContent timeout (s)",
      "extraGetRetriesLabel": "Extra GET retries on network failure",
      "extraGetRetriesTitle": "How many times to retry a single task status request (GET /tasks) on SocketError, timeouts, etc.",
      "getRetryPauseLabel": "Pause between GET retries (s)",
      "httpProxyUrl": "HTTP proxy URL",
      "providerOptions": {
        "klingImages": "Kling (images)",
        "chatgptImageN8n": "ChatGPT Image (n8n GPT Image)",
        "qwenImage": "Qwen Image",
        "wanImage": "Wan 2.7 Image",
        "openrouterNanoBanana": "OpenRouter (Nano Banana 2)",
        "googleGeminiImage": "Google Gemini (image)"
      }
    },
    "sections": {
      "n8n": {
        "navLabel": "ChatGPT (n8n)",
        "navHint": "webhook · token",
        "bannerTitle": "ChatGPT via n8n",
        "bannerSubtitle": "Webhook for text generation: structure and shots via ChatGPT. Token and authorization header mode.",
        "postJsonHint": "POST JSON: prompt, system_prompt. Header: Bearer (custom) or standard Authorization: Bearer.",
        "enableLabel": "Enable text generation via n8n",
        "testButton": "Test n8n"
      },
      "n8n_prompt_improver": {
        "navLabel": "Prompt improvement (n8n)",
        "navHint": "webhook · shots",
        "bannerTitle": "Prompt improvement via n8n",
        "bannerSubtitle": "Separate webhook for improving user shot and video prompts in the shot panel. Own token and authorization mode.",
        "postJsonHint": "POST JSON: prompt (source text), system_prompt (target generation model). Response — improved prompt text.",
        "enableLabel": "Enable prompt improvement via n8n",
        "testButton": "Test webhook",
        "videoPromptRulesTitle": "Video prompt improvement rules by provider",
        "videoPromptRulesHint": "Text is merged into the system prompt when kind=video. Selected by the project's effective video provider (override → Platform Config → legacy column).",
        "seedanceRulesLabel": "Seedance 2 (BytePlus / OpenRouter)",
        "seedanceRulesProvidersHint": "Providers: byteplus_seedance_video, openrouter_video",
        "klingRulesLabel": "Kling",
        "klingRulesProviderHint": "Provider: kling",
        "wanRulesLabel": "WAN",
        "wanRulesProviderHint": "Provider: wan"
      },
      "gpt_image": {
        "navLabel": "GPT Image (n8n)",
        "navHint": "webhook · storyboard",
        "bannerTitle": "GPT Image via n8n",
        "bannerSubtitle": "Webhook for storyboard images via GPT Image. Token and authorization mode — shared with ChatGPT (Text section).",
        "requestBodyHint": "Request body: system_prompt, prompt, aspect_ratio (e.g. 9:16). Response is JSON with image URL. Token and authorization mode — shared with ChatGPT (Text section).",
        "webhookUrlLabel": "Webhook URL (GPT Image)",
        "testButton": "Test GPT Image",
        "testHint": "At least one shot is required in the database. Save URL and token first (Text → ChatGPT section)."
      },
      "dashscope_storyboard": {
        "navLabel": "Qwen / Wan Image (storyboard)",
        "navHint": "multimodal-generation",
        "bannerTitle": "Qwen / Wan Image: storyboard",
        "bannerSubtitle": "Two model families: Qwen Image and Wan 2.7 Image — different parameters; up to three references; Alibaba Model Studio API.",
        "intro": "Vertical storyboard frame via POST …/api/v1/services/aigc/multimodal-generation/generation. This is not video — video settings are under WAN (video). The pipeline uses up to three public reference URLs (location and character outfits). The default key matches WAN; the separate field below overrides it for images only. Pick a family first — Qwen Image and Wan 2.7 image are different model lines and parameters. Documentation: Qwen-Image API, Wan 2.7 image API.",
        "modelFamilyTitle": "Model family",
        "qwenImageFamily": "Qwen Image",
        "wanImageFamily": "Wan 2.7 image (万相)",
        "specificModelLabel": "Specific model (selected family only)",
        "optionalApiKeyLabel": "Separate API Key for storyboard (optional)",
        "optionalApiKeySaved": "— already saved",
        "optionalApiKeyNotSet": "— not set",
        "optionalApiKeyEmptyPlaceholder": "Empty — uses WAN key",
        "wanSectionHint": "Base URL and HTTP timeout — in the WAN (video) section. Save settings before testing.",
        "testButton": "Test Qwen / Wan Image",
        "testHint": "Real request to the selected model; do not click often due to quota and cost."
      },
      "openrouter": {
        "navLabel": "OpenRouter",
        "navHint": "Nano Banana · Seedance",
        "bannerTitle": "OpenRouter (images and video)",
        "bannerSubtitle": "Universal gateway: images (Nano Banana 2 / Gemini 3.1 Flash) and video (Seedance 2.0). One API key — many models; model and resolution — in project settings.",
        "intro": "Unified API gateway openrouter.ai: one key — images and video. Images: Nano Banana 2 (Gemini 3.1 Flash Image Preview). Video: Seedance 2.0 (ByteDance) — model and resolution are chosen in project settings.",
        "enableLabel": "Enable OpenRouter",
        "projectsOverrideModelHint": "Projects can override the model in their settings.",
        "videoSectionTitle": "Video via OpenRouter",
        "videoSectionHint": "Available models: {{models}}. Resolutions: {{resolutions}}. Model and resolution are set at the project level (Settings → API Models → Video → Seedance 2.0 (OpenRouter)). Uses the same API key and Base URL as images.",
        "apiKeyPlaceholder": "sk-or-… from openrouter.ai/keys",
        "videoPollTimeout": "Video timeout = {{seconds}}s ({{minutes}} min)",
        "testButton": "Test OpenRouter",
        "testHint": "Real request to the selected model via OpenRouter. Save the key first."
      },
      "covers": {
        "navLabel": "Covers and references",
        "navHint": "cover · character_reference",
        "bannerTitle": "Covers and character reference sheets",
        "bannerSubtitle": "16:9 poster and character sheet — Kling, n8n GPT Image, Qwen / Wan Image or OpenRouter; key and base URL — in the provider section.",
        "intro": "After story approval in the project overview, a 16:9 poster is generated in the background: Kling, webhook GPT Image (n8n) or Qwen Image or Wan 2.7 Image (same models as storyboard; in production the first hero reference sheet URL can be attached to the poster).",
        "coverProviderLabel": "Cover provider",
        "coverModelLabel": "Cover model",
        "coverDashscopeHint": "API and key — in the Qwen / Wan Image: storyboard nav section. For Qwen a horizontal 16:9 size is set.",
        "fallbackCoverPromptLabel": "Fallback cover system prompt (if empty in System prompts)",
        "fallbackCoverPromptHintBefore": "Main poster text — in",
        "fallbackCoverPromptHintAfter": "(key project_cover). Write here only if that field is empty: title, genre, tone and a story excerpt are added to the request.",
        "characterReferenceTitle": "Character reference sheet (16:9)",
        "characterReferenceIntroBefore": "Generated from the Characters workspace. System text is set in",
        "characterReferenceIntroAfter": "(key character_reference_sheet). Credentials — same as cover: Kling, GPT Image (n8n) or Qwen / Wan Image.",
        "characterReferenceProviderLabel": "Character reference provider",
        "characterReferenceModelLabel": "Reference sheet model",
        "klingOutfitsTitle": "Kling: character outfits (image2image)",
        "klingOutfitsHint": "Parameters for image2image when generating outfits (clothing/accessories). Projects inherit these values unless they set their own.",
        "klingOutfitsModelLabel": "Kling model for outfits",
        "klingOutfitsModelHint": "kling-v1-5 — the only model supporting image_fidelity and image_reference. Empty = kling-v1-5.",
        "klingOutfitsFidelityLabel": "Outfit image_fidelity",
        "klingOutfitsFidelityHint": "0..1. Higher — stricter face and body preservation. Default 0.6.",
        "locationReferenceTitle": "Location reference (16:9)",
        "locationReferenceIntroBefore": "Generated from the Locations workspace. System text is set in",
        "locationReferenceIntroAfter": "(keys location_three_quarter_reference / location_topview_reference / location_reference_sheet / location_variant_reference). Shared credentials: Kling, GPT Image (n8n) or Qwen / Wan Image.",
        "locationReferenceProviderLabel": "Location reference provider",
        "locationReferenceModelLabel": "Location reference model",
        "klingVariantModelLabel": "Kling: model for image2image variants",
        "klingVariantModelHint": "Applies only when provider is Kling. Empty = kling-v1-5: only this model actually honors image_fidelity on endpoint /v1/images/generations. On kling-v2 the parameter is ignored and the variant is effectively text-generated (geometry and layout are lost). On kling-v1-5 image2image API always requires image_reference — we send subject: at high image_fidelity it preserves scene geometry while the user prompt changes lighting / weather / time of day.",
        "klingVariantFidelityLabel": "Kling: location variant image_fidelity",
        "klingVariantFidelityHint": "How strictly to follow the base location reference (0 — loose, 1 — maximum fidelity). For scene geometry we recommend 0.8–0.9."
      },
      "kling": {
        "navLabel": "Kling AI",
        "navHint": "document API",
        "bannerTitle": "Kling AI",
        "bannerSubtitle": "Official API: text2video, image2video, generations. API Key or legacy JWT (Access + Secret Key). Image model is used for covers and references.",
        "apiIntro": "Official Kling AI API: Authorization: Bearer with a single API Key (recommended) or legacy JWT from Access Key + Secret Key. Documentation: kling.ai/document-api. Requests: POST /v1/videos/text2video / POST /v1/videos/image2video, status GET …/{task_id}; images: POST /v1/images/generations.",
        "authModeLabel": "Authentication",
        "authModeApiKey": "API Key (recommended)",
        "authModeJwt": "Access Key + Secret Key (legacy JWT)",
        "authModeHint": "New Kling developer keys use a single API Key. Legacy accounts may still use Access Key + Secret Key pair.",
        "enableLabel": "Enable Kling API",
        "defaultImageModelLabel": "Image model for covers / references (optional)",
        "testButton": "Test Kling (create text2video)",
        "testHint": "Each test creates a real Kling task. Frequent clicks trigger HTTP 429 (rate limit) — wait a few minutes."
      },
      "wan": {
        "navLabel": "WAN (video)",
        "navHint": "video-synthesis",
        "bannerTitle": "WAN (video)",
        "bannerSubtitle": "i2v / r2v by model; async Alibaba Model Studio API; public storyboard URL.",
        "intro": "Alibaba Model Studio: API Key in Authorization: Bearer, header X-DashScope-Async: enable. Documentation: 参考生视频 API. For models with i2v in id (e.g. wan2.6-i2v-flash) image-to-video is sent: input.img_url and a regular video prompt. For r2v — also reference_urls and character1 prefix in text. Shot storyboard URL must be public HTTPS.",
        "enableLabel": "Enable WAN",
        "modelModeHint": "r2v — with hero/location references; i2v — start frame only",
        "apiKeyPlaceholder": "sk-… from Model Studio console",
        "getRetriesHint": "Retries apply only to status polling (GET), not task creation (POST) — to avoid duplicate tasks in WAN.",
        "testButton": "Test WAN (create test video-synthesis task)",
        "testHint": "Creates a real task in Alibaba Model Studio (public demo image from documentation). Do not click often — consider quota and cost."
      },
      "byteplus_seedance": {
        "navLabel": "BytePlus Seedance",
        "navHint": "ModelArk · Dreamina 2.0",
        "bannerTitle": "BytePlus ModelArk — Seedance 2.0",
        "bannerSubtitle": "Direct Ark API (ap-southeast region): POST /api/v3/contents/generations/tasks; image and video references, first/last frame. Key: console.byteplus.com → ModelArk → API keys.",
        "intro": "Official BytePlus ModelArk — Video generation API. Base URL without /api/v3 (default https://ark.ap-southeast.bytepluses.com). Model and resolution for projects — in workspace settings (video → Seedance 2.0 BytePlus).",
        "enableLabel": "Enable BytePlus Seedance (ModelArk)",
        "resolutionsHint": "Resolutions: {{resolutions}}.",
        "apiKeyPlaceholder": "ARK API key from BytePlus ModelArk",
        "pollTimeoutApprox": "Poll timeout ≈ {{seconds}}s",
        "assetLibraryTitle": "Asset library (Private Avatar)",
        "assetLibraryHint": "Separate AK/SK (SigV4) request signing. Used to register characters and outfits as Seedance virtual assets.",
        "assetBaseUrl": "Asset library base URL",
        "assetRegion": "Region",
        "assetProjectName": "Project name",
        "assetAccessKeyId": "Access Key ID",
        "assetSecretAccessKey": "Secret Access Key"
      },
      "google_ai_studio": {
        "navLabel": "Google AI Studio",
        "navHint": "Gemini image · Veo",
        "bannerTitle": "Google AI Studio (Gemini / Veo)",
        "bannerSubtitle": "One API key and base URL (Gemini API): images via generateContent with responseModalities IMAGE; video via Veo (predictLongRunning and operation polling).",
        "docsIntro": "Documentation: ai.google.dev/gemini-api. Key and base URL — from Google AI Studio; header x-goog-api-key. Default models can be overridden in project settings.",
        "enableLabel": "Enable Google AI Studio (Gemini image + Veo)",
        "apiKeyPlaceholder": "Key from Google AI Studio",
        "geminiImageSection": "Gemini (images)",
        "testGeminiButton": "Test Gemini image",
        "testGeminiHint": "Real generateContent request; consider quota. Save the key before testing.",
        "veoSection": "Veo (video)",
        "testVeoButton": "Test Veo (operation creation only)",
        "testVeoHint": "Sends predictLongRunning without full polling and MP4 download."
      },
      "gemini_video_transcription": {
        "navLabel": "Animatic transcription",
        "navHint": "Gemini 2.5 Pro · transcription",
        "bannerTitle": "Animatic segment transcription (Gemini 2.5 Pro)",
        "bannerSubtitle": "Analysis of animatic video segments via Gemini 2.5 Pro: composition, actions, dialogue, camera. Uses the same base URL (Google AI Studio); separate key or fallback to shared.",
        "intro": "Gemini 2.5 Pro analyzes a short animatic video segment (with audio) and returns structured JSON: composition, camera, actions, dialogue, prompt notes. Base URL and proxy — shared with Google AI Studio. You can set a separate API key; if empty — uses Google AI Studio key (fallback).",
        "enableLabel": "Enable animatic segment transcription",
        "separateApiKeyLabel": "Separate API Key",
        "separateApiKeyNotSetFallback": "(not set — fallback to shared Google AI Studio)",
        "separateApiKeyEmptyPlaceholder": "Empty — uses Google AI Studio key",
        "fallbackKeyInUse": "Using shared Google AI Studio key (fallback)",
        "testButton": "Test configuration",
        "testHint": "Checks config validity only (key presence, base URL). No real API request is made."
      },
      "topaz_post_production": {
        "navLabel": "Topaz",
        "navHint": "video enhancement",
        "bannerTitle": "Topaz Labs API — processing",
        "bannerSubtitle": "AI video enhancement and upscaling through Topaz Labs. Model families and API versions are stored in the processing catalog.",
        "intro": "Topaz Labs video API uses X-API-Key and asynchronous video requests: create request, accept/upload, complete upload, then poll status. The catalog stores Proteus-family model schemas; these settings store connection and polling parameters.",
        "enableLabel": "Enable Topaz processing",
        "baseUrlHint": "Store the root URL. The future client will append /video/ and request-specific paths.",
        "apiKeyPlaceholder": "API key from account.topazlabs.com/manage-api",
        "apiKeyHint": "Sent as X-API-Key. The value is encrypted and never returned to the browser.",
        "retryHint": "Topaz docs recommend retrying after HTTP 429 with backoff. These values are for future upload/status calls.",
        "noTestHint": "No test button yet: the quickstart flow creates a real request and requires uploading a video file."
      },
      "outbound_proxy": {
        "navLabel": "Outbound proxy",
        "navHint": "HTTP → sing-box / VLESS",
        "bannerTitle": "Proxy for AI API calls",
        "bannerSubtitle": "HTTP(S) mixed (e.g. sing-box in Kamal: http://sing-box:7890). Enabled separately per provider. Vless:// is set only in sing-box container secrets, not here.",
        "intro": "Specify HTTP or HTTPS proxy (CONNECT for outbound HTTPS). In production with Kamal accessory sing-box usually http://sing-box:7890. Then check providers whose requests should go through the proxy.",
        "testProxyHintBefore": "The button below uses",
        "testProxyHintSaved": "already saved",
        "testProxyHintAfter": "proxy URL from the database. After editing the field, save settings first. The request goes to api.ipify.org — response shows egress public IP; compare with your exit node IP (VLESS). If IP matches the server IP without tunnel — proxy is not used.",
        "testProxyButton": "Test proxy (external IP)",
        "proxyProviders": {
          "n8nChatgpt": "n8n ChatGPT (text)",
          "n8nGptImage": "n8n GPT Image",
          "kling": "Kling",
          "wan": "WAN (video DashScope)",
          "dashscopeMultimodal": "DashScope images (Qwen / Wan multimodal)",
          "openrouter": "OpenRouter",
          "byteplusSeedance": "BytePlus Seedance (ModelArk)",
          "googleAiStudio": "Google AI Studio (Gemini + Veo)",
          "topaz": "Topaz Labs"
        }
      }
    }
  },
  "generationModels": {
    "index": {
      "title": "Model registry",
      "create": "Add model",
      "providerConnections": "Provider connections",
      "empty": "No models found. Run it2tv:generation_models:sync.",
      "search": "Search by name or key…",
      "searchEmpty": "No models match your search.",
      "filters": {
        "mediaKind": "Media kind",
        "usageContext": "Usage context",
        "active": "Status",
        "all": "All",
        "activeOnly": "Active only",
        "inactiveOnly": "Inactive only"
      },
      "table": {
        "displayName": "Name",
        "key": "Key",
        "mediaKind": "Kind",
        "routes": "Routes",
        "status": "Status"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "platformHints": {
        "coverDashscope": "API and key — in Provider connections → DashScope. For Qwen a horizontal 16:9 size is set.",
        "klingOutfitsModel": "kling-v1-5 — the only model supporting image_fidelity and image_reference. Empty = kling-v1-5.",
        "klingOutfitsFidelity": "0..1. Higher — stricter face and body preservation. Default 0.6.",
        "klingVariantModel": "Applies only when provider is Kling. Empty = kling-v1-5: only this model honors image_fidelity on /v1/images/generations.",
        "klingVariantFidelity": "How strictly to follow the base location reference (0 — loose, 1 — maximum fidelity). For scene geometry we recommend 0.8–0.9."
      }
    },
    "show": {
      "back": "← Back to models",
      "editingNow": "Currently editing",
      "saving": "Saving…",
      "sections": {
        "details": "Model settings",
        "usages": "Usage contexts",
        "routes": "Provider routes"
      },
      "fields": {
        "displayName": "Display name",
        "family": "Family",
        "position": "Sort order",
        "active": "Active",
        "max_image_parts": "Max image references",
        "max_video_refs": "Max video references",
        "max_audio_refs": "Max audio references",
        "max_video_ref_seconds": "Max seconds per video reference",
        "max_audio_ref_seconds": "Max seconds per audio reference",
        "max_total_video_ref_seconds": "Max total video-reference seconds",
        "max_total_audio_ref_seconds": "Max total audio-reference seconds"
      },
      "capabilities": {
        "title": "Additional parameters",
        "durations": "Durations (sec)",
        "addDuration": "Add",
        "removeDuration": "Remove {{duration}}s",
        "aspectRatios": "Aspect ratios",
        "addAspectRatio": "Add",
        "removeAspectRatio": "Remove {{ratio}}",
        "extraParams": "Extra parameters",
        "addParam": "Add parameter",
        "removeParam": "Remove",
        "newParam": "New parameter",
        "paramKey": "Key",
        "paramKind": "Type",
        "paramOptions": "Options",
        "paramOptionsPlaceholder": "4K",
        "addOption": "Add",
        "removeOption": "Remove {{option}}",
        "paramDefault": "Default value",
        "emptyDefault": "Not set",
        "enabledByDefault": "Enabled by default",
        "kindSelect": "Select",
        "kindBoolean": "Yes/no",
        "kindNumber": "Number",
        "noExtraParams": "No extra parameters",
        "metadataGroup": "Catalog group",
        "metadataGroupPlaceholder": "Qwen Image"
      },
      "routes": {
        "active": "Active route",
        "activate": "Set active"
      }
    },
    "usageContexts": {
      "canvas_image": "Canvas image",
      "canvas_video": "Canvas video",
      "storyboard": "Storyboard",
      "shot_video": "Shot video",
      "location_reference": "Location reference",
      "character_reference": "Character reference",
      "character_outfit": "Character outfit",
      "cover": "Cover image",
      "storyboard_correction": "Storyboard correction",
      "video_correction": "Video correction",
      "transcription": "Transcription",
      "post_production": "Processing",
      "voice_tts": "Voice TTS",
      "audio_transcription": "Audio transcription",
      "voice_creation": "Voice creation",
      "voice_sts": "Voice conversion",
      "agent": "Agent",
      "lipsync": "Lipsync",
      "sketch": "Sketch correction",
      "previz_depth": "Previz depth map"
    },
    "origin": {
      "catalog": "catalog",
      "studio": "Studio"
    },
    "new": {
      "title": "New model",
      "eyebrow": "Connect to a provider",
      "hint": "The model appears in pickers after save. Provider-specific API quirks are not inferred from the form.",
      "clone": {
        "label": "Copy from existing model",
        "placeholder": "Select a model to prefill…",
        "hint": "Change the registry key, display name, and wire code before saving, or they will collide with the source model."
      },
      "saving": "Creating…",
      "submit": "Create model",
      "fields": {
        "key": "Registry key",
        "provider": "Provider",
        "integration": "Integration",
        "wireCode": "Provider wire code",
        "wireCodeHint": "This exact code is sent to the API. It can differ from the registry key.",
        "familyHint": "seedance — tokens and a required video_input cost row; kling — required audio cost, and audio tariff when GPL is a priced row.",
        "grantAllowlist": "Grant to companies with model allowlists"
      },
      "billing": {
        "title": "Rates (required)",
        "hint": "USD cost fallback without resolution is required. GPL values are copied from the clone into new rows for this model. Empty GPL is not allowed: enter a price or choose free (0 RUB).",
        "familyVariants": "This family also needs a filled {{variant}} row.",
        "cost": "USD cost",
        "tariff": "GPL tariff, RUB",
        "tariffMode": "GPL",
        "tariffModeCustom": "Set tariff",
        "tariffModeFree": "Free (0 RUB)",
        "tariffFreeHint": "Save creates new GPL rows at 0 RUB. The source model is not changed.",
        "resolutionAny": "resolution (empty = any)",
        "variant": "variant",
        "addCost": "Add cost row",
        "addTariff": "Add tariff row",
        "removeRow": "Remove"
      }
    }
  },
  "integrationPlatform": {
    "title": "Platform config",
    "sectionsHeading": "Generation targets",
    "sectionsHint": "Select an entity — model settings and platform fields are on the right.",
    "filterPlaceholder": "Search by name…",
    "clearFilter": "Clear search",
    "filterEmpty": "No matches.",
    "editingNow": "Currently editing",
    "defaultModel": "Default (from storyboard family)",
    "targetGroups": {
      "text": "Text",
      "image": "Images",
      "video": "Video",
      "audio": "Sound",
      "processing": "Processing",
      "system": "System"
    },
    "targets": {
      "promptImprover": {
        "title": "Video prompt improvement rules",
        "description": "Text rules for video providers that are already used by the prompt improver pipeline."
      },
      "agent": {
        "description": "Default chat model for the project assistant agent.",
        "reasoningEffortLabel": "Reasoning effort",
        "reasoningEffortHint": "Controls GLM deep thinking for all assistants. Lower is faster; higher may improve complex tool planning and prompt quality.",
        "reasoningEffortOptions": {
          "disabled": "Off — fastest, no chain-of-thought",
          "high": "High — balanced (default)",
          "max": "Max — deepest reasoning, slowest"
        }
      },
      "agentTools": {
        "title": "Assistant tools",
        "description": "Enable or disable tools available to the project assistant, and choose which actions require confirmation in the UI.",
        "navHint": "Enable / confirm",
        "toolColumn": "Tool",
        "enabledColumn": "Enabled",
        "confirmColumn": "Confirm",
        "modes": {
          "shots_assistant": "Shots",
          "characters_assistant": "Characters",
          "locations_assistant": "Locations",
          "props_assistant": "Props",
          "canvas_assistant": "Canvas",
          "skills_discussion_assistant": "Skills discussion",
          "skills_editor_assistant": "Skills editor",
          "skills_assistant": "Skills",
          "script_assistant": "Script",
          "projects_assistant": "Studio projects",
          "tasks_assistant": "Tasks",
          "scene3d_assistant": "3D scenes",
          "notes": "Notes"
        },
        "tools": {
          "improve_prompt": "Improve shot prompt",
          "update_shot_duration": "Update shot duration",
          "regenerate_keyframe": "Regenerate keyframe",
          "regenerate_video": "Regenerate video",
          "generate_project_cover": "Generate project cover",
          "create_next_shot": "Create next shot",
          "create_shots_batch": "Create shots batch",
          "create_transition_shot": "Create transition shot",
          "create_character": "Create character",
          "update_character": "Update character",
          "delete_character": "Delete character",
          "create_outfit": "Create outfit",
          "update_outfit": "Update outfit",
          "generate_character_reference": "Generate character reference",
          "generate_character_sheet": "Generate character sheet",
          "generate_character_emotion_sheet": "Generate emotion sheet",
          "generate_character_portrait": "Generate portrait",
          "generate_character_scale_pose": "Generate scale pose",
          "generate_character_media": "Generate character media",
          "register_seedance_avatar": "Register Seedance avatar",
          "create_location": "Create location",
          "update_location": "Update location",
          "delete_location": "Delete location",
          "generate_location_reference": "Generate location reference",
          "create_prop": "Create prop",
          "update_prop": "Update prop",
          "delete_prop": "Delete prop",
          "extract_props_from_script": "Extract props from script",
          "generate_prop_reference": "Generate prop reference",
          "generate_prop_front_view": "Generate prop front view",
          "update_canvas_prompt": "Update canvas prompt",
          "set_canvas_media_kind": "Set canvas media kind",
          "update_canvas_settings": "Update canvas settings",
          "start_canvas_generation": "Start canvas generation",
          "update_generation_skill": "Update skill",
          "create_project": "Create project",
          "list_tasks": "List tasks",
          "get_task": "Read task",
          "list_task_description_versions": "Task description history",
          "create_task": "Create task",
          "update_task": "Update task",
          "list_task_assignees": "List task assignees",
          "list_task_mentionable_people": "List people to mention in tasks",
          "add_task_comment": "Add task comment",
          "update_task_comment": "Edit own task comment",
          "attach_task_file": "Attach task file as reference",
          "propose_episode_script": "Propose a script version",
          "list_notes": "List notes",
          "get_note": "Read note",
          "write_notes": "Create or update notes"
        }
      },
      "mcpTools": {
        "title": "MCP tools",
        "description": "Enable or disable tools that Claude and other MCP clients can call. Generation tools stay off until you turn them on.",
        "navHint": "Enable / disable",
        "toolColumn": "Tool",
        "enabledColumn": "Enabled",
        "groups": {
          "storyboard": "Storyboard",
          "canvas": "Canvas",
          "entities": "Characters, locations, props",
          "story": "Story",
          "tasks": "Tasks",
          "notes": "Notes",
          "generate": "Shot generation",
          "flow": "Flow"
        },
        "tools": {
          "list_projects": "List projects",
          "list_shots": "List shots",
          "get_shot_prompts": "Read shot prompts",
          "set_shot_prompt": "Write shot prompt",
          "create_shot": "Create shot",
          "create_transition_shot": "Create transition shot",
          "update_shot_intent": "Update shot intent",
          "list_canvas_boards": "List canvas boards",
          "list_canvas_generations": "List canvas generations",
          "get_canvas_generation": "Read canvas generation",
          "get_canvas_prompt": "Read canvas draft",
          "set_canvas_prompt": "Write canvas draft",
          "generate_canvas": "Generate on canvas",
          "list_characters": "List characters",
          "get_character": "Read character",
          "create_character": "Create character",
          "update_character": "Update character",
          "list_locations": "List locations",
          "get_location": "Read location",
          "create_location": "Create location",
          "update_location": "Update location",
          "list_props": "List props",
          "get_prop": "Read prop",
          "create_prop": "Create prop",
          "update_prop": "Update prop",
          "get_story": "Read story",
          "update_story": "Update story",
          "list_scenes": "List scenes",
          "create_scene": "Create scene",
          "list_tasks": "List tasks",
          "get_task": "Read task",
          "list_task_description_versions": "Task description history",
          "create_task": "Create task",
          "update_task": "Update task",
          "list_task_assignees": "List task assignees",
          "list_task_mentionable_people": "List people to mention in tasks",
          "add_task_comment": "Add task comment",
          "update_task_comment": "Edit own task comment",
          "generate_shot_storyboard": "Generate shot storyboard",
          "generate_shot_video": "Generate shot video",
          "list_notes": "List notes",
          "get_note": "Read note",
          "write_notes": "Create or update notes",
          "list_flow_boards": "List flow boards",
          "list_flow_nodes": "List flow nodes",
          "get_flow_node": "Read flow node",
          "create_flow_board": "Create flow board",
          "create_flow_node": "Create flow node",
          "update_flow_node": "Update flow node",
          "remove_flow_node": "Remove flow node",
          "connect_flow_nodes": "Connect flow nodes",
          "disconnect_flow_edge": "Disconnect flow nodes",
          "generate_flow_nodes": "Generate on flow"
        }
      },
      "storyboard": {
        "description": "Models for storyboard and shot reference frames."
      },
      "cover": {
        "description": "Models and platform defaults for project cover generation."
      },
      "characterReference": {
        "description": "Models and defaults for character reference generation."
      },
      "characterOutfit": {
        "description": "Models and parameters for character outfit generation."
      },
      "locationReference": {
        "description": "Models and defaults for location reference generation."
      },
      "canvasImage": {
        "description": "Models for image generation on canvas."
      },
      "storyboardCorrection": {
        "description": "Models for reference frame correction."
      },
      "sketch": {
        "description": "Models for AI correction in the sketch editor."
      },
      "shotVideo": {
        "description": "Models for shot video generation."
      },
      "canvasVideo": {
        "description": "Models for video generation on canvas."
      },
      "videoCorrection": {
        "description": "Models for video correction."
      },
      "previzDepth": {
        "description": "Model for the gray and color previz depth maps."
      },
      "transcription": {
        "description": "Models for animatic recognition and transcription."
      },
      "audioTranscription": {
        "description": "Models for recognizing shot audio tracks and dialogue."
      },
      "voiceCreation": {
        "description": "Models for Voice Design, Remix, and Instant Voice Cloning."
      },
      "voiceTts": {
        "description": "Models for character voice preview TTS."
      },
      "postProduction": {
        "description": "Models for video enhancement, upscaling, and processing."
      },
      "outboundProxy": {
        "title": "Outbound proxy",
        "description": "System outbound proxy setting for generation.",
        "providersTitle": "Providers via proxy",
        "providersEmpty": "No global provider connections."
      },
      "videoOutput": {
        "title": "Video output",
        "description": "Default frame rate for video normalization after generation or upload. Projects can inherit or override this. Changing it affects new files.",
        "fpsLabel": "Output FPS",
        "fpsHint": "Applied when normalizing videos after generation or upload. Project Settings → General can override per project.",
        "fpsOption": "{{fps}} fps",
        "fpsValue": "{{fps}} fps"
      }
    },
    "modelRegistry": {
      "title": "Models for selected target",
      "hint": "Available models and routes for \"{{context}}\".",
      "hintPrefix": "Available models and routes for:",
      "openFilteredRegistry": "Open registry",
      "openModel": "Model card",
      "empty": "No active registry models are available for this target yet.",
      "capabilities": "Capabilities",
      "durations": "Durations",
      "extraParams": "Parameters",
      "noRoutes": "No routes configured for this model.",
      "connectionConfigured": "Connection configured",
      "connectionNotConfigured": "Connection not configured"
    },
    "modelSelection": {
      "title": "Model for selected target",
      "hintPrefix": "The selected model generates entities for:",
      "fieldLabel": "Model",
      "openFilteredRegistry": "Open registry",
      "openModel": "Model card",
      "empty": "No active registry models are available for this target yet.",
      "capabilities": "Capabilities",
      "durations": "Durations",
      "extraParams": "Parameters",
      "activeRoute": "Active provider route",
      "noActiveRoute": "No active route configured. Choose it in the model card or on the Providers page.",
      "connectionConfigured": "Connection configured",
      "connectionNotConfigured": "Connection not configured",
      "noModelSelected": "No model selected",
      "noModelTarget": "No model selection"
    }
  },
  "providerConnections": {
    "index": {
      "title": "Provider connections",
      "creatingNow": "Creating new",
      "editingNow": "Currently editing",
      "emptyList": "No connections yet.",
      "create": "Create",
      "filterPlaceholder": "Search by name…",
      "clearFilter": "Clear search",
      "filterEmpty": "No matches.",
      "newTitle": "New connection",
      "emptySelection": "Select a connection on the left or create a new one.",
      "confirmDelete": "Delete this connection?",
      "test": "Test",
      "checkBalance": "Check balance",
      "routesCount": "Linked routes: {{count}}",
      "routes": {
        "title": "Routes",
        "summary": "{{active}} active of {{total}}",
        "empty": "No linked routes yet. Run it2tv:generation_models:sync or recreate the connection.",
        "active": "Active",
        "activate": "Activate",
        "activateAll": "Activate all"
      },
      "filters": {
        "providerKind": "Provider",
        "all": "All"
      },
      "fields": {
        "providerKind": "Provider kind",
        "name": "Name",
        "priority": "Priority",
        "apiBaseUrl": "API base URL",
        "enabled": "Enabled",
        "proxyEnabled": "Use proxy",
        "tosMirrorEnabled": "References via TOS",
        "notes": "Notes"
      },
      "credentials": {
        "title": "Credentials",
        "configured": "Credentials set",
        "notConfigured": "Credentials not set",
        "apiKey": "API key",
        "storyboardApiKey": "Storyboard API key (optional)",
        "transcriptionApiKey": "Transcription API key (optional)",
        "accessKey": "Access key",
        "secretKey": "Secret key",
        "authValue": "Auth token",
        "authMode": "Authentication",
        "authModeApiKey": "API Key (recommended)",
        "authModeJwt": "Access Key + Secret Key (legacy JWT)",
        "leaveBlank": "Leave blank to keep current value"
      },
      "balance": {
        "title": "Balance",
        "unsupported": "Balance monitoring is not available for this provider.",
        "neverChecked": "Balance has not been checked yet.",
        "lastChecked": "Last checked: {{date}}",
        "remaining": "Remaining",
        "spendingTitle": "Spending intensity",
        "spendingUnavailable": "Not enough balance history yet (need at least 2 checks).",
        "spendPerDay": "~{{amount}} / day",
        "spendPerHour": "~{{amount}} / hour",
        "daysRemaining": "~{{days}} days remaining at current rate",
        "checkFailed": "Last check failed: {{message}}",
        "klingDelayNote": "Kling credit balances may lag by up to ~12 hours.",
        "byteplusDelayNote": "BytePlus billing data may lag by up to ~1 hour.",
        "byteplusSpentSinceSync": "Spent since pack sync: {{amount}} tokens",
        "byteplusConsumedMtd": "Consumed this month",
        "byteplusMtdSpend": "Month-to-date bill: {{amount}}",
        "units": {
          "usd": "${{amount}}",
          "credits": "{{amount}} credits",
          "tokens": "{{amount}} tokens"
        }
      },
      "timing": {
        "title": "Timeouts and polling"
      },
      "settings": {
        "title": "Provider options",
        "webhookUrl": "Webhook URL",
        "authMode": "Auth mode",
        "authModeBearerHeader": "Bearer header (custom)",
        "authModeAuthorizationBearer": "Authorization: Bearer",
        "requestTimeoutSec": "Request timeout (s)",
        "pollIntervalSec": "Poll interval (s)",
        "pollMaxAttempts": "Max poll attempts",
        "videoPollIntervalSec": "Video poll interval (s)",
        "veoPollIntervalSec": "Veo poll interval (s)",
        "httpMaxRetries": "Extra GET retries",
        "httpRetryIntervalSec": "Pause between GET retries (s)",
        "byteplusAdminApiBaseUrl": "Asset/admin API base URL",
        "transcriptionEnabled": "Enable Gemini video transcription",
        "transcriptionModel": "Transcription model",
        "transcriptionRequestTimeoutSec": "Transcription timeout (s)",
        "veoResolution": "Veo resolution",
        "resolution720p": "720p",
        "resolution1080p": "1080p"
      },
      "byteplusBilling": {
        "title": "Billing (ModelArk)",
        "hint": "AK/SK are used for usage and bill APIs (fallback: asset keys on this connection). Resource pack remaining is optional — without it we show consumption only. Choose Pay as you go for postpaid billing.",
        "billingMode": "Billing mode",
        "modeResourcePack": "Resource pack (tokens)",
        "modePayAsYouGo": "Pay as you go (USD)",
        "packRemainingTokens": "Pack remaining (tokens, optional)",
        "packRemainingPlaceholder": "If known from Console — enables remaining estimate",
        "packTotalTokens": "Pack total (optional)",
        "projectName": "ModelArk project name",
        "region": "API region",
        "assetCredentialsTitle": "Access Key ID + Secret Access Key (optional)",
        "assetCredentialsHint": "Used only for usage/billing and asset/admin APIs. ModelArk generation uses the API key from the Credentials block.",
        "accessKeyId": "Access Key ID",
        "secretAccessKey": "Secret Access Key",
        "resourcePacksLink": "Resource packs docs",
        "monitoringLink": "ModelArk monitoring"
      },
      "hints": {
        "testUsesSaved": "The request uses saved URL and credentials. Save changes before testing.",
        "kling": {
          "authMode": "New Kling developer keys use a single API Key. Legacy accounts may still use Access Key + Secret Key pair.",
          "test": "Each test creates a real Kling task. Frequent clicks trigger HTTP 429 (rate limit) — wait a few minutes."
        },
        "openrouter": {
          "apiKeyPlaceholder": "sk-or-… from openrouter.ai/keys",
          "test": "Real request to the selected model via OpenRouter. Save the key first."
        },
        "wan": {
          "apiKeyPlaceholder": "sk-… from Model Studio console",
          "getRetries": "Retries apply only to status polling (GET), not task creation (POST) — to avoid duplicate tasks in WAN.",
          "test": "Creates a real task in Alibaba Model Studio. Do not click often — consider quota and cost."
        },
        "byteplus_seedance": {
          "apiKeyPlaceholder": "ARK API key from BytePlus ModelArk",
          "assetLibrary": "Separate AK/SK (SigV4) request signing. Used to register characters and outfits as Seedance virtual assets."
        },
        "google_ai_studio": {
          "docs": "Documentation: ai.google.dev/gemini-api. Key and base URL — from Google AI Studio; header x-goog-api-key.",
          "apiKeyPlaceholder": "Key from Google AI Studio",
          "testGemini": "Real generateContent request; consider quota. Save the key before testing."
        },
        "n8n_chatgpt": {
          "postJson": "POST JSON: prompt, system_prompt. Header: Bearer (custom) or standard Authorization: Bearer."
        },
        "n8n_prompt_improver": {
          "postJson": "POST JSON: prompt (source text), system_prompt (target generation model). Response — improved prompt text."
        },
        "n8n_gpt_image": {
          "requestBody": "Request body: system_prompt, prompt, aspect_ratio (e.g. 9:16). Token and authorization mode — shared with ChatGPT connection.",
          "test": "At least one shot is required in the database. Save URL and token first."
        },
        "dashscope": {
          "storyboardApiKey": "Empty — uses WAN key from this provider connection.",
          "test": "Real request to the selected model; do not click often due to quota and cost."
        },
        "topaz": {
          "apiKey": "Sent as X-API-Key. The value is encrypted and never returned to the browser.",
          "retry": "Topaz docs recommend retrying after HTTP 429 with backoff. These values are for upload/status calls.",
          "noTest": "No test button yet: the quickstart flow creates a real request and requires uploading a video file."
        },
        "cloud": {
          "apiKey": "Sent as X-API-KEY. Leave blank if server authentication is off.",
          "baseUrl": "http://127.0.0.1:8080 is a placeholder. Enter the server address."
        },
        "outbound_proxy": {
          "intro": "Specify HTTP or HTTPS proxy (CONNECT for outbound HTTPS). In production with Kamal accessory sing-box usually http://sing-box:7890."
        }
      }
    }
  },
  "generationSkills": {
    "headTitle": "Skills",
    "studioTitle": "System skills",
    "companyTitle": "Company skills",
    "listTitle": "Skills",
    "selectHint": "Select a skill on the left to edit it.",
    "empty": "No skills yet.",
    "filterPlaceholder": "Search skills…",
    "filterEmpty": "No skills match the filter.",
    "clearFilter": "Clear search",
    "levels": {
      "project": "Project",
      "company": "Company",
      "system": "System"
    },
    "add": "Add",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Short summary for the skills library",
    "slugLabel": "Short name",
    "slugHint": "Used as /short-name in the agent chat. Letters, digits, hyphens.",
    "bodyLabel": "Skill body",
    "bodyPlaceholder": "Describe how the assistant should behave for this skill.",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved",
    "saveFailed": "Could not save",
    "delete": "Delete",
    "deleteConfirmTitle": "Delete skill “{{name}}”?",
    "deleteConfirmMessage": "This cannot be undone.",
    "destroyBlocked": "Skill is used in assignments",
    "activeLabel": "Active",
    "fileToSkillUpload": "Upload skill",
    "fileToSkillHint": "The model will rewrite the document into a skill: a short Russian title and summary, plus dense working instructions for the assistant — not a verbatim dump of the file. The result is saved to this skill immediately.",
    "fileToSkillFormats": "Supported formats: .txt, .md (max ~100k tokens / 400k characters, ~1.5 MB).",
    "fileToSkillDropHint": "Drop a file here or choose one",
    "fileToSkillBadFormat": "Only .txt and .md files are supported",
    "fileToSkillUploading": "Uploading…",
    "fileToSkillQueued": "Queued…",
    "fileToSkillProcessing": "Generating skill…",
    "fileToSkillFailed": "Could not create skill from file",
    "fileToSkillSaveStuck": "Skill was generated but could not be saved. Try again.",
    "fileImportModeConvert": "Convert",
    "fileImportModeDirect": "As skill",
    "fileImportDirectHint": "Upload a ready .txt or .md skill. Optional YAML frontmatter (name, description); otherwise the whole file becomes the skill body and the name comes from the filename.",
    "fileImportSaved": "Skill uploaded from the file.",
    "assignmentsTitle": "Assignments",
    "assignmentsNav": "Skill assignments",
    "discussTab": "Discuss",
    "editTab": "Edit",
    "assignmentsHint": "Higher-level skills are kept; lower levels append. Order within a level is preserved when applied.",
    "addSkill": "Add skill",
    "newSkillName": "New skill",
    "layerSystem": "System",
    "layerCompany": "Company",
    "sectionOther": "Other",
    "sectionNone": "No section",
    "sectionLabel": "Section",
    "sectionEmpty": "No skills",
    "addSection": "Add section",
    "renameSection": "Rename",
    "renameSectionPrompt": "Section name",
    "deleteSection": "Delete",
    "deleteSectionConfirmTitle": "Delete section “{{name}}”?",
    "deleteSectionConfirmMessage": "Skills will become unsectioned. This cannot be undone.",
    "dragReorder": "Drag to reorder",
    "removeSkill": "Remove",
    "loading": "Loading skills…",
    "loadFailed": "Could not load skills",
    "groups": {
      "assistants": "Assistants",
      "vision": "Visual analysis"
    },
    "usageContexts": {
      "shots_assistant": "Overview / Storyboard",
      "characters_assistant": "Characters",
      "locations_assistant": "Locations",
      "props_assistant": "Props",
      "canvas_assistant": "Canvas",
      "flow_assistant": "Flow",
      "skills_discussion_assistant": "Skills discussion",
      "skills_editor_assistant": "Skills editor",
      "skills_assistant": "Skills",
      "script_assistant": "Script",
      "projects_assistant": "Studio projects",
      "scene3d_assistant": "3D scenes",
      "vision_image": "Images",
      "vision_video": "Video"
    },
    "fileToSkillSaved": "Skill saved from the file.",
    "readonlyInheritedHint": "This inherited skill is open for reference. Switch to your own level to save edits.",
    "platformContentHiddenHint": "Platform skill content is available only to the platform administrator."
  }
}
